import { AttributeRestriction,  RestrictionAttribute } from "components/restrictions/Restrictions";
import { ComponentDefinition, DisplayedComponent, isInputComponent, RestrictableComponent } from "./Component";
import { ValueBaseComponent } from "./ValueBaseComponent";

export abstract class InputBaseComponent<T extends ComponentDefinition>
    extends ValueBaseComponent<T>
    implements RestrictableComponent, DisplayedComponent {

    constructor(schema: T) {
        super(schema);
        this.definition = schema;
    }

    public abstract setValidationStatus(valid: boolean, message?: string): void;

    public applyRestrictions(restrictions: AttributeRestriction) {
        if (restrictions == null || restrictions.attributes == null) {
            return;
        }
        super.applyRestrictions(restrictions);
        if (isInputComponent(this)) {
            this.setReadOnly(restrictions.attributes.includes(RestrictionAttribute.readonly));
            this.setRequired(restrictions.attributes.includes(RestrictionAttribute.required));
        }
    }
}
